var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications_FILL0_wght500_GRAD200_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.24056 13.5646C3.03987 13.5646 2.87164 13.4967 2.73587 13.3609C2.60011 13.2252 2.53223 13.0629 2.53223 12.874C2.53223 12.6733 2.60011 12.508 2.73587 12.3781C2.87164 12.2483 3.03987 12.1833 3.24056 12.1833H4.07285V7.03021C4.07285 6.03855 4.37094 5.13247 4.96712 4.31198C5.5633 3.4915 6.35723 2.9573 7.34889 2.70938V2.21355C7.34889 1.8948 7.46105 1.63212 7.68535 1.42553C7.90966 1.21893 8.18118 1.11563 8.49993 1.11563C8.81869 1.11563 9.09021 1.21893 9.31452 1.42553C9.53882 1.63212 9.65098 1.8948 9.65098 2.21355V2.70938C10.6426 2.94549 11.4425 3.47379 12.0505 4.29428C12.6584 5.11476 12.9624 6.02674 12.9624 7.03021V12.1833H13.7947C13.9718 12.1833 14.1282 12.2512 14.264 12.387C14.3998 12.5227 14.4676 12.6851 14.4676 12.874C14.4676 13.0629 14.3998 13.2252 14.264 13.3609C14.1282 13.4967 13.9718 13.5646 13.7947 13.5646H3.24056ZM8.49993 15.849C8.08674 15.849 7.72962 15.6984 7.42858 15.3974C7.12754 15.0964 6.97702 14.7392 6.97702 14.326H10.0229C10.0229 14.751 9.87528 15.1111 9.58014 15.4063C9.285 15.7014 8.92493 15.849 8.49993 15.849ZM5.4541 12.1833H11.5812V7.03021C11.5812 6.16841 11.289 5.43941 10.7046 4.84323C10.1202 4.24705 9.39716 3.94896 8.53535 3.94896C7.66174 3.94896 6.9298 4.24705 6.33952 4.84323C5.74924 5.43941 5.4541 6.16841 5.4541 7.03021V12.1833Z",
    fill: "#19191D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.ecb9de9c952a2e693ed387db515e96da.svg";
export { ForwardRef as ReactComponent };